"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStateMachineRegistry = exports.INITIALIZE_STATE_MACHINE = void 0;
const lodash_1 = require("lodash");
const INITIALIZE = '@@xstate/INITIALIZE';
exports.INITIALIZE_STATE_MACHINE = INITIALIZE;
exports.createStateMachineRegistry = () => {
    let pendingInitializations = [];
    let currentTransitions = [];
    return {
        register(...transitions) {
            currentTransitions = [...currentTransitions, ...transitions];
            pendingInitializations = [...pendingInitializations, ...transitions];
        },
        unregister(...transitions) {
            currentTransitions = lodash_1.without(currentTransitions, ...transitions);
            pendingInitializations = lodash_1.without(pendingInitializations, ...transitions);
        },
        process(getState, action) {
            pendingInitializations.forEach(transition => transition(getState, { type: INITIALIZE }));
            pendingInitializations = [];
            if (action.type)
                currentTransitions.forEach(transition => transition(getState, action));
        },
    };
};
